import { Container, IconContainer } from "./style";

interface IconsTopBarProps {
  selected: string;
  settings: {
    value: string;
    title: string;
    icon: JSX.Element;
  }[];
  setSelected: (value: string) => void;
}

export default function IconsTopBar({
  selected,
  settings,
  setSelected,
}: IconsTopBarProps) {
  return (
    <Container>
      {settings.map((setting) => {
        const isSelected = selected === setting.value;

        return (
          <IconContainer
            key={setting.value}
            isSelected={isSelected}
            onClick={() => setSelected(setting.value)}
          >
            {setting.icon}
          </IconContainer>
        );
      })}
    </Container>
  );
}
